'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InlineOverlayBody = function InlineOverlayBody(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;
  return _react2.default.createElement(
    'div',
    { className: 'content-body ' + className },
    children
  );
};

InlineOverlayBody.displayName = 'InlineOverlayBody';
InlineOverlayBody.propTypes = {
  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired,
  className: _react2.default.PropTypes.string
};

exports.default = InlineOverlayBody;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-inline-overlay/lib/components/inline-overlay-body/components/InlineOverlayBody.component.js
// module id = 1317
// module chunks = 1